import {
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    FETCH_PROFILE_SUCCESS,
    FETCH_PROFILE_FAILURE,
    CLEAR_USER_ERROR,
  } from './actionTypes.js';
  
  const initialState = {
    user_id: null,
    username: null,
    email: null,
    loading: false,
    error: null,
  };
  
  const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOGIN_SUCCESS:
        return { ...state, user_id: action.payload, error: null };
  
      case LOGIN_FAILURE:
        return { ...state, error: action.payload };
  
      case LOGOUT_SUCCESS:
        return { ...state, user_id: null, username: null, email: null, loading: null, error: null };
  
      case LOGOUT_FAILURE:
        return { ...state, error: action.payload };
  
      case FETCH_PROFILE_SUCCESS:
        return { ...state, username: action.payload.username, email: action.payload.email, error: null };
  
      case FETCH_PROFILE_FAILURE:
        return { ...state, error: action.payload };

      case CLEAR_USER_ERROR:
        return { ...state, error: null };
  
      default:
        return state;
    }
  };
  
  export default userReducer;
  